import { Flex } from "antd";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { OrderStatusService } from "../../../../services/order_statuses/order_status.service";
import { OrderStatusModel } from "../../../../services/order_statuses/models/order_status.model";
import { toast } from "react-toastify";
import * as signalR from "@microsoft/signalr";
import { OrderHubUrl } from "../../../../consts/api";
import { useSelector } from "react-redux";
import { getCompanyId } from "../../../../react-reduxs/slices/auth/auth_slice";
import { OrderHubEnum } from "../../../../enums/order_hub.enum";
import {
  OrderProductStatusEnum,
  OrderStatusEnum,
} from "../../../../enums/orders/order_status.enum";
import ThemeButton from "@theme/ui-components/buttons/ThemeButton";
import ThemeDialog from "@theme/ui-components/dialogs/ThemeDialog";
import { OrderStateModel } from "../../../../services/orders/models/order_state.model";
interface CloseOrderDrawerProps {
  order?: OrderStateModel;
}

const CloseOrderDrawer: React.FC<CloseOrderDrawerProps> = ({ order }) => {
  const orderStatusService = useMemo(() => new OrderStatusService(), []);
  const companyId = useSelector(getCompanyId);
  const allowedStatuses = [
    OrderProductStatusEnum.delivered,
    OrderProductStatusEnum.cancelled,
    OrderProductStatusEnum.outOfStock,
  ];

  const [orderStatusModelList, setOrderStatusModelList] = useState<
    OrderStatusModel[]
  >([]);
  const [count, setCount] = useState<number>(0);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const init = useCallback(async () => {
    let response = await orderStatusService.getList();
    if (response) {
      setOrderStatusModelList(response);
    }
  }, [orderStatusService]);

  useEffect(() => {
    setCount((cou) => {
      if (cou === 0) {
        init();
      }
      return 1;
    });
    return () => {};
  }, []);

  const closeOrder = useCallback(
    async (orderStatusId: number) => {
      // İzin verilen statülerin DIŞINDA bir ürün var mı?
      const hasRestrictedProducts = order?.orderProductList.some(
        (x) =>
          !allowedStatuses.includes(x.status.name as OrderProductStatusEnum),
      );

      if (hasRestrictedProducts) {
        toast.error(
          "Sipariş içerisinde henüz sonuçlanmamış ürünler bulunuyor.",
        );
        return;
      }
      const connection = new signalR.HubConnectionBuilder()
        .withUrl(OrderHubUrl(companyId).url)
        .withAutomaticReconnect()
        .configureLogging(signalR.LogLevel.Information)
        .build();

      try {
        await connection
          .start()
          .then(() => {
            console.log("SignalR bağlantısı kuruldu.WaiterHub");
          })
          .catch((error) => {
            console.error(
              "SignalR bağlantısı başlatılırken hata oluştu:",
              error,
            );
          });
        console.error(
          companyId,
          order?.order.id,
          orderStatusId,
          order?.order.tableId,
        );

        await connection.invoke(
          OrderHubEnum.orderClose,
          companyId,
          order?.order.id,
          orderStatusId,
          order?.order.tableId,
        );
      } catch (error) {
        console.error("SignalR bağlantısı başlatılırken hata oluştu:", error);
      } finally {
        connection.stop();
      }
    },
    [companyId, order],
  );

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        style={{
          background: "#059669",
          color: "#fff",
          fontWeight: 800,
          fontSize: 13,
          padding: "12px 24px", // Yatayda biraz boşluk daha iyi durur
          borderRadius: 12,
          border: "none",
          cursor: "pointer",
          width: "100%", // Drawer içindeyse tam genişlik daha şık olur
        }}
      >
        {"Hesap Kes"}
      </button>

      <ThemeDialog
        header={"Ödeme Onayı ve Hesap Kapatma"}
        visible={isOpen}
        appendTo={document.body}
        modal={true}
        onHide={() => setIsOpen(false)}
        style={{ margin: "10px" }} // Daha derli toplu bir görünüm için
      >
        <Flex vertical gap="middle">
          {/* Bilgi Metni */}
          <div
            style={{
              fontSize: "14px",
              color: "#4b5563",
              textAlign: "center",
              marginBottom: "10px",
            }}
          >
            {
              "Masa hesabı kapatılacak ve ödeme tamamlandı olarak işaretlenecektir. Onaylıyor musunuz?"
            }
          </div>

          <Flex gap="small" justify="center">
            {orderStatusModelList
              .filter((x) => x.text === OrderStatusEnum.paymentCompleted)
              .map((x) => (
                <ThemeButton
                  key={x.id.toString()}
                  className="flex-1"
                  outlined={false}
                  severity="success"
                  disabled={x.id === order?.order.statusId}
                  label="Ödemeyi Onayla ve Kapat"
                  onClick={() => {
                    closeOrder(x.id);
                    setIsOpen(false); // İşlem sonrası dialogu kapat
                  }}
                />
              ))}
          </Flex>

          <ThemeButton
            severity="danger"
            itemType="text"
            label="Vazgeç"
            onClick={() => setIsOpen(false)}
          />
        </Flex>
      </ThemeDialog>
    </>
  );
};

export default CloseOrderDrawer;
